function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { ContextualMenu, DialogType } from '@fluentui/react';
import { getWindow } from '../services/window';
import { Constants } from '@shared/utils/constants';
import g2Logo from '@shared/images/g2-logo.svg';
import { camelCase, keyBy, keys, mapKeys } from 'lodash-es';
export function launchTelemetry(action, actionModifier, telemetryDetails) {
    const payload = {
        page: getWindow().location.href,
        action,
        actionModifier,
        details: JSON.stringify(telemetryDetails)
    };
}
const providersNames = {
    AppSource: Constants.StorefrontName.AppSource,
    Marketplace: Constants.StorefrontName.AppSource,
    Amp: 'Azure Marketplace',
    G2: Constants.StorefrontName.G2
};
export const getProviderNameByReviewSource = (provider, defaultName)=>{
    return providersNames[provider] || defaultName;
};
export function getReviewCtaButtonText(context, userReview) {
    if (userReview) {
        return context.loc('AppReviewCollection_Button_Text_Edit', 'Edit your review');
    }
    return context.loc('AppReviewCollection_Button_Text_Write', 'Write a review');
}
export function getAddReviewSectionDescription(context, isPurchased) {
    if (!isPurchased) {
        return context.loc('AppReviewCollection_addReviewDescription_Text', 'To submit your rating and review, first get the \napp and let us know about your experience');
    }
    return '';
}
export const getReviewModalDialogProps = (title)=>{
    const dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };
    const modalPropsStyles = {
        main: {
            maxWidth: 650
        },
        scrollableContent: {
            width: 560
        }
    };
    return {
        dialogContentProps: {
            type: DialogType.normal,
            title: title
        },
        modalProps: {
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: dragOptions
        },
        maxWidth: 560
    };
};
export const getReviewCommentsModalDialogProps = (title)=>{
    const dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };
    const modalPropsStyles = {
        main: {
            maxWidth: 650
        },
        scrollableContent: {
            width: 560
        }
    };
    return {
        dialogContentProps: {
            type: DialogType.normal,
            title: title
        },
        modalProps: {
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: dragOptions
        },
        maxWidth: 560
    };
};
export const createDefaultPagination = (reviews)=>{
    const defaultPagination = {
        startIndex: 1,
        endIndex: 1,
        pageIndex: 1
    };
    if (reviews && reviews.length > 0) {
        defaultPagination.endIndex = reviews.length > Constants.MaxItemsPerPageInReviews ? Constants.MaxItemsPerPageInReviews : reviews.length;
    }
    return defaultPagination;
};
export const createDeepLinkPagination = (reviews, reviewId)=>{
    const result = createDefaultPagination(reviews);
    if ((reviews === null || reviews === void 0 ? void 0 : reviews.length) > 0 && reviewId) {
        reviews.some((review, index)=>{
            if (review.id === reviewId) {
                const currentPageIndex = Math.trunc(index / Constants.MaxItemsPerPageInReviews);
                result.startIndex = currentPageIndex * Constants.MaxItemsPerPageInReviews + 1;
                result.pageIndex = currentPageIndex + 1;
                result.endIndex = Math.min(result.startIndex + Constants.MaxItemsPerPageInReviews - 1, reviews.length);
                return true;
            }
            return false;
        });
    }
    return result;
};
export const combineDeletedComments = ({ commentsById, commentIds })=>{
    return commentIds.reduce((acc, currId, currIdx)=>{
        const currentComment = commentsById[`${currId}`];
        // Accumulate deleted comments
        if (currentComment.isDeleted) {
            acc.deletedAccumulator = [
                ...acc.deletedAccumulator,
                currId
            ];
        }
        // At the end of the array, or if encountering a normal comment, add the deleted comments or just one if they surpass the limit
        if (!currentComment.isDeleted || currIdx >= commentIds.length - 1) {
            // If the subsequent deleted comments number reaches the limit, only add one
            acc.result = [
                ...acc.result,
                ...acc.deletedAccumulator.length >= Constants.Reviews.MaxSubsequentDeletedComments ? [
                    acc.deletedAccumulator[0]
                ] // Add first one
                 : acc.deletedAccumulator
            ];
            // Reset the accumulator
            acc.deletedAccumulator = [];
        }
        if (!currentComment.isDeleted) {
            acc.result = [
                ...acc.result,
                currId
            ];
        }
        return acc;
    }, {
        deletedAccumulator: [],
        result: []
    }).result;
};
export const createInitialReviewCommentsState = ()=>{
    return {
        commentIds: [],
        commentsById: {},
        reducedCommentIds: [],
        isLoading: false,
        newlyAddedComments: [],
        totalComments: 0,
        currentLoadedPage: 0,
        totalPages: 0
    };
};
export const appendReviewCommentsToState = (state, comments)=>{
    const commentsById = keyBy(comments, 'id');
    const newState = _object_spread_props(_object_spread({}, state), {
        commentsById: _object_spread({}, state.commentsById, commentsById),
        commentIds: [
            ...state.commentIds,
            ...keys(commentsById)
        ]
    });
    return _object_spread_props(_object_spread({}, newState), {
        // Merge consequent deleted comments
        reducedCommentIds: combineDeletedComments(newState)
    });
};
export const mapEnrichReviewCommentToIAppReviewComment = (comment)=>{
    const keyMapper = (v, key)=>camelCase(key);
    const { customer_info: customerInfo } = comment;
    return _object_spread_props(_object_spread({}, mapKeys(comment, keyMapper)), {
        customerInfo: mapKeys(customerInfo, keyMapper)
    });
};
export const calculateTotalReviewCommentsPagesCount = (totalComments)=>{
    if (totalComments) {
        return Math.ceil(totalComments / Constants.Reviews.CommentsPerPage);
    }
    return 0;
};
export const getExternalRatingSummaries = (ratingSummaries = [])=>{
    const externalRatingSummaries = [];
    const g2Summary = ratingSummaries.find((summary)=>summary.Source === Constants.StorefrontName.G2);
    if (g2Summary) {
        externalRatingSummaries.push({
            ratingSummary: g2Summary,
            image: g2Logo
        });
    }
    return externalRatingSummaries;
};
export const getRatingTotals = (ratingSummaries)=>{
    return (ratingSummaries || []).filter((externalRatingSummary)=>externalRatingSummary.AverageRating && !isNaN(externalRatingSummary.AverageRating) && externalRatingSummary.TotalRatings && externalRatingSummary.Source === Constants.StorefrontName.G2).reduce((accumulatedRatings, currentRating)=>({
            totalRatingCounts: accumulatedRatings.totalRatingCounts + currentRating.TotalRatings,
            totalAverageRatingsSum: accumulatedRatings.totalAverageRatingsSum + currentRating.AverageRating * currentRating.TotalRatings
        }), {
        totalRatingCounts: 0,
        totalAverageRatingsSum: 0
    });
};
export const getTotalExternalRatingSummariesInfo = (ratingSummaries)=>{
    const { totalRatingCounts, totalAverageRatingsSum } = getRatingTotals(ratingSummaries);
    return {
        totalRatings: totalRatingCounts,
        averageRatings: totalRatingCounts ? totalAverageRatingsSum / totalRatingCounts : 0
    };
};
export const getRatingSummaryByType = (ratingSummaries, source)=>{
    return ratingSummaries === null || ratingSummaries === void 0 ? void 0 : ratingSummaries.find((option)=>option.Source === source);
};
export const findReviewsSources = ({ reviews })=>{
    const { Marketplace, AppSource, Amp, Ibiza } = Constants.StorefrontName;
    const hasInternalReviews = reviews.some((review)=>[
            Marketplace,
            AppSource,
            Amp,
            Ibiza
        ].includes(review.source));
    const hasExternalReviews = reviews.some((review)=>review.source === Constants.StorefrontName.G2);
    return {
        hasExternalReviews,
        hasInternalReviews
    };
};
